import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const DeliveryCompanySettings = () => {
	const defaultSort = useMemo(() => [{ id: 'deliveryCompId', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'deliveryCompId',
				accessor: 'deliveryCompId',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'name',
				accessor: 'name',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.string
			},
			{
				Header: 'agreementType',
				accessor: 'agreementType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SHIPPING_PRICE_AGREEMENT_TYPE
			},
			{
				Header: 'JsonSettings',
				accessor: 'JsonString',
				filterType: FilterType.string
			},
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'creditRefundPeriod',
				accessor: 'creditRefundPeriod',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'deliverySLA',
				accessor: 'deliverySLA',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'pickupSLA',
				accessor: 'pickupSLA',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'pickupAllCities',
				accessor: 'pickupAllCities',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			},
			{
				Header: 'companyType',
				accessor: 'companyType',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'dailyCapacity',
				accessor: 'dailyCapacity',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'serviceType',
				accessor: 'serviceType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DC_CONTRACT_SERVICE_TYPES,
				show: false
			},
			{
				Header: 'returnMethod',
				accessor: 'returnMethod',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'webhookToken',
				accessor: 'webhookToken',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'modifiedDate',
				accessor: 'modifiedDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'modifiedBy',
				accessor: 'modifiedBy',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'dcEscalationReceiverEmail',
				accessor: 'escalationEmail',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<DynamicList
			id={DYNAMICLISTS.DELIVERY_COMPANY_SETTINGS}
			columns={columns}
			fetchUrl={ADMIN.DELIVERY_COMPANY_SETTINGS.GET_DC_LIST}
			exportName="deliveryCompanySettings"
			defaultSort={defaultSort}
			actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
		/>
	);
};

export default DeliveryCompanySettings;
